// extracted by mini-css-extract-plugin
export default {"pageLayout":"Clients_pageLayout__EBLFL","buttons":"Clients_buttons__P5XLB","btn":"Clients_btn__V4omv"};